module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Prepper’s Communication Handbook")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "rch1",
      "title": "CHAPTER 1: One-Way Radio: Receivers"
    }
  }, [_c('p', {
    staticClass: "chano"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch1"
    }
  }, [_c('b', [_vm._v("Chapter 1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "chati"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch1"
    }
  }, [_c('b', [_vm._v("ONE-WAY RADIO: RECEIVERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Most of you already have one or more radios kicking around the house, even if it is just the one in the car or truck. I’ll start the journey through prepper communication options with one-way radios, which are thusly named because information only flows one way—to you from the broadcasting channel or station.")]), _vm._v(" "), _c('p', {
    staticClass: "subhe"
  }, [_c('b', [_vm._v("AM/FM")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("AM/FM radio has been omnipresent for decades and is the first thing that comes to mind when the topic of radio comes up. Despite recent advances in technology, there is still something to be said for good, old-fashioned broadcast radio.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("AM stands for amplitude modulation. As the name would imply, an AM signal is one in which the amplitude, or peak of the transmission wave, is modulated or varied. Most of AM broadcasts consist of talk radio, sports, and religious discussions, with a bit of music tossed in here and there across the dial. It has been that way for the last few decades and likely won’t be changing any time soon. AM channels range from 540 kHz to 1,700 kHz, spaced at every 10 kHz. For the uninitiated, kHz stands for kilohertz.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("For many, AM radio is pretty much a snooze-fest. Not a lot goes on there that gets the blood pumping, other than the occasional ball game.")]), _vm._v(" "), _c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "10",
      "src": "images/line.jpg",
      "width": "799"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subhe1"
  }, [_c('b', [_vm._v("BASIC TYPES OF RADIOS")])]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_vm._v("Broadcast radio has been in the United States since around the 1920s. Since then, it has evolved from a hobby enjoyed by those who could puzzle out the complexities of radio equipment to a major force in family entertainment. Nowadays, it seems as though radio often plays second (or perhaps third) fiddle to other means of information transmission. Certainly television supplanted radio’s position as the chief entertainer in the household from about the 1950s through the early 2000s. Of course, you can’t discount the impact of video streaming and other online mediums, either. There are four basic categories of radios:")]), _vm._v(" "), _c('p', {
    staticClass: "squa"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "3",
      "src": "images/squ.jpg",
      "width": "3"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "3",
      "src": "images/squ.jpg",
      "width": "3"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("Handheld.")]), _vm._v(" These are small radios, roughly the size of a walkie-talkie.")])]), _vm._v(" "), _c('p', {
    staticClass: "squa"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "3",
      "src": "images/squ.jpg",
      "width": "3"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "3",
      "src": "images/squ.jpg",
      "width": "3"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("Mobile.")]), _vm._v(" These radios are installed in vehicles, somewhat akin to CB radios in semis (see "), _c('span', {
    attrs: {
      "href": "#/text/Chapter2#page_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 21")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "squa"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "3",
      "src": "images/squ.jpg",
      "width": "3"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "3",
      "src": "images/squ.jpg",
      "width": "3"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("Portable.")]), _vm._v(" These rigs are larger than handheld units but can still be easily carried to different locations.")])]), _vm._v(" "), _c('p', {
    staticClass: "squa"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "height": "3",
      "src": "images/squ.jpg",
      "width": "3"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "3",
      "src": "images/squ.jpg",
      "width": "3"
    }
  })]), _c('span', {
    staticClass: "spacea"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("Base.")]), _vm._v(" These radios are large and stationary. They have the most output power but also consume the most resources to operate.")])]), _vm._v(" "), _c('p', {
    staticClass: "imageta"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "10",
      "src": "images/line.jpg",
      "width": "799"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("However, there is an interesting twist to AM radio. For the most part, the broadcasts are local. In the middle of the afternoon, you’re going to be tuning in to shows being broadcast within 200 miles or so. But when the sun goes down, the ionosphere changes and, as a result, the AM radio waves can travel much farther, perhaps 500 miles or more. This is easily tested by sitting in your car during the day and scrolling through the AM dial, then repeating the process late at night. You’ll likely hear far more broadcasts by the light of the moon.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Why is this notable? If the disaster at hand were regional, local news stations might not have the capacity to broadcast. But stations from outside the affected area will certainly share the information they’re able to gather, and it is from them that you might learn more about what’s going on.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "103",
      "src": "images/cap1.jpg",
      "width": "149"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "captionk"
  }, [_c('b', [_vm._v("Westminster Model 1425 Multi-Band Receiver")])]), _vm._v(" "), _c('p', {
    staticClass: "captionk0"
  }, [_vm._v("This multi-band receiver was found for a couple of dollars at a rummage sale. It will tune in not only the standard AM/FM and shortwave transmissions but also weather alert stations, some police frequencies, and CB radio. It is rather old but still works very well.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("FM stands for frequency modulation. With AM signals, the frequency remains constant and the amplitude changes, but with FM, the frequency is varied. For most people, this part of the radio dial is most familiar. In the United States, full-power FM stations run from 88.1 to 107.9 MHz. Because of the way the channels are allocated, the frequency will always end in an odd number. Those who routinely listen to broadcast radio hear the bulk of their music and news on these channels.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("FM channels are always local affairs. The average range for the higher-powered stations is about 100 to 150 miles. FM stations are great for entertainment and news, provided the news isn’t affecting your immediate area.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("AM/FM radios are obviously extremely common. Odds are you have several at your disposal already, such as the radio sitting in your kitchen or in the garage workshop.")]), _vm._v(" "), _c('p', {
    staticClass: "subhe"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_c('b', [_vm._v("SATELLITE RADIO")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In the last several years, satellite radio has become extremely popular. It is subscription based and, of course, a satellite radio is required to receive the broadcasts. The great thing about satellite radio is the sheer entertainment value. I spend a lot of time in my car and have grown to love the diverse range of options I have with my Sirius subscription. Most of the channels are focused on one specific genre, such as old-time radio shows, 1980s hair metal, or even Jimmy Buffett–style beach music. Naturally, there are all sorts of news stations, too, like CNN.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("One of the downsides is the expense. The subscription alone can be costly, unless you’re able to negotiate a lower figure. I’ve never paid full price for my satellite radio subscription. I just tell my provider that I can’t afford whatever they tell me the going rate is, and they’ll keep moving the number down until I’m comfortable with it. Granted, were she alive today, my grandmother would give me grief for paying for radio, but at least I’m not shelling out $100 a month for it.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("I wouldn’t recommend satellite radio as your primary means of collecting information, but if you already subscribe to it, consider adding a small, portable receiver to your bag of tricks. If nothing else, you should be able to download and install a satellite radio app on your phone or tablet. If you go that route, be sure to verify that your subscription plan will allow you to use the radio in your vehicle as well as the portable one.")]), _vm._v(" "), _c('p', {
    staticClass: "subhe"
  }, [_c('b', [_vm._v("SHORTWAVE")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Shortwave (SW) transmissions can be sent around the world by bouncing them off of the ionosphere, so named because of the high concentration of ions in this strata of the atmosphere, roughly 50 to 600 miles from the Earth’s surface. This ion-rich environment allows you to tune in to broadcasts from all over the place. SW, unlike amateur (HAM) radio, is one way. A station transmits and you receive. You aren’t able to communicate back on an SW radio.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Most SW broadcasts are prerecorded. They might consist of music, talk, or even just a mysterious voice rattling off numbers (Google “shortwave numbers station”). History has shown that SW broadcasts are generally free of censorship, even in countries where violations of radio silence carry severe punishment. Therefore, a SW broadcast is likely to contain reliable facts, at least as far as the broadcaster believes them to be true.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Of course, there’s always the possibility of rumor being reported as fact. You’ve got to take the good with the bad. The key part of SW for your purposes is that the overseas broadcasts likely won’t be designed strictly to keep people calm and thus won’t be sanitized or edited to withhold the very information you’ll be seeking.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "118",
      "src": "images/cap2.jpg",
      "width": "144"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "captionk"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_c('b', [_vm._v("Kaito Voyager Pro Emergency Radio")])])]), _vm._v(" "), _c('p', {
    staticClass: "captionk0"
  }, [_vm._v("One of the best emergency radios on the market today is the Kaito Voyager Pro. It is powered by batteries, crank, or the small solar panel you see on top. It will tune in AM/FM/SW and weather radio stations. It can power your cell phone via a small USB port, plus an LED flashlight and SOS emergency light.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Some SW radios allow the user to listen to various HAM frequencies as well. Again, though, the SW radio is a listen-only device. Look for a designation of single sideband (SSB) when researching SW radios. Sideband is what HAM operators use to transmit voice. Occasionally, it will be labeled upper sideband and lower sideband (USB/LSB). With these options, the transmitting signal utilizes a carrier frequency to communicate the audio signal. Two additional signals that are mirror images of one another go along for the ride on either side of the carrier signal. These are the upper and lower sidebands and where the information being relayed actually resides in the transmission. A SSB receiver is able to decode the sideband transmissions into an audible signal. Again, I’m only talking about a SW receiver, not any sort of transmitter, so this is only for gathering information, not sending anything out.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "127",
      "src": "images/cap3.jpg",
      "width": "126"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "captionk"
  }, [_c('b', [_vm._v("Sony ICF-5900W Multi-Band Receiver")])]), _vm._v(" "), _c('p', {
    staticClass: "captionk0"
  }, [_vm._v("This multi-band receiver was inherited from my father and is roughly 40 years old. It still works great for listening to AM/FM and some shortwave transmissions.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("SW radio listening can be a very fun hobby. Many people keep track of the different stations they find—this is called DXing. One resource for finding broadcasts is "), _c('a', {
    attrs: {
      "href": "http://PrimeTimeShortwave.com",
      "target": "_blank"
    }
  }, [_vm._v("PrimeTimeShortwave.com")]), _vm._v(". There, you can find broadcasts from all over the world. Another resource is "), _c('a', {
    attrs: {
      "href": "http://ShortwaveSchedule.com",
      "target": "_blank"
    }
  }, [_vm._v("ShortwaveSchedule.com")]), _vm._v(". You might also consider purchasing the "), _c('i', [_vm._v("World Radio TV Handbook,")]), _vm._v(" a best-selling directory of global broadcasting. A new edition is issued every year.")])]), _vm._v(" "), _c('p', {
    staticClass: "subhe"
  }, [_c('b', [_vm._v("NOAA")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("NOAA stands for National Oceanic and Atmospheric Administration, which many people think of as the weather radio stations. Indeed, one of the primary functions of the NOAA radio stations is to broadcast weather reports. These reports are typically far more detailed and accurate than the ones you’ll see on TV.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("NOAA weather broadcasts are updated every few hours, more frequently if conditions warrant. They are repeated every 5 minutes, give or take, 24 hours a day, 365 days a year. The broadcasts you’ll hear are for your local area, not some far-flung city.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "117",
      "src": "images/cap4.jpg",
      "width": "126"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "captionk"
  }, [_c('b', [_vm._v("Eton FR-300 Emergency Radio")])]), _vm._v(" "), _c('p', {
    staticClass: "captionk0"
  }, [_vm._v("This radio not only receives AM/FM and shortwave transmissions but weather alerts as well. Crank power means you don’t have to rely on batteries. Plus, there’s a small flashlight built in to the unit.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("In order to listen to NOAA broadcasts, you’ll need either a specific type of receiver called a “weather radio” or a radio that specifies it will receive weather band broadcasts. Most radios marketed as “emergency radios” will receive the NOAA broadcasts in addition to AM/FM, and sometimes shortwave (SW). Here’s where it gets interesting. Many weather radios sold today have what is called Specific Area Message Encoding, or SAME, as well as an alarm of some sort. National Weather Service forecasters can, when necessary, insert a signal that activates the alarm feature of weather alert radios in the affected area. Given the NOAA broadcast system design, if a warning were issued for your area and your radio were turned on, you’d be alerted to the danger with a tonal alarm or other signal.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("In 1975, the NOAA system was formally designated as the only government-operated radio system for sending out warnings related to natural disasters, nuclear attack, and other such emergencies. It remains so today. In other words, your weather radio is one of the primary ways you may be warned of an impending disaster. And you thought it was mostly for seeing if the weather is going to be nice enough for a picnic later!")])]), _vm._v(" "), _c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "10",
      "src": "images/line.jpg",
      "width": "799"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subhe1"
  }, [_c('b', [_vm._v("PHONETIC ALPHABETS")])]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_vm._v("Because there are several letters in the English alphabet that sound very similar to one another, such as B, D, and T, most law enforcement agencies as well as other government departments use a phonetic alphabet when transmitting over the air. There are two primary alphabets, one used by military and aviation and the other by law enforcement.")]), _vm._v(" "), _c('div', {
    staticClass: "image-container6"
  }, [_c('figure', [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticClass: "block6",
    attrs: {
      "alt": "",
      "height": "473",
      "src": "images/tab1.jpg",
      "width": "318"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "imageta"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "10",
      "src": "images/line.jpg",
      "width": "799"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subhe"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_c('b', [_vm._v("RADIO SCANNER")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Sometimes referred to as a police scanner, a radio scanner is awesome for gathering information from a variety of sources, including government agencies and private businesses. It works somewhat like a standard radio in that you need to tune it to specific frequencies in order to listen (see Programming a Radio Scanner on page 14). Once programmed, it will scan those frequencies, pausing any time it detects radio traffic. You could forgo the programming and let it scroll through every single frequency, but that could take a while.")]), _vm._v(" "), _c('div', {
    staticClass: "image-container25"
  }, [_c('figure', [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    staticClass: "block25",
    attrs: {
      "alt": "",
      "height": "188",
      "src": "images/cap5.jpg",
      "width": "106"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "captionk"
  }, [_c('b', [_vm._v("Radio Shack PRO-64 Scanner")])]), _vm._v(" "), _c('p', {
    staticClass: "captionk0"
  }, [_vm._v("This is an older model radio scanner but still quite useful for listening to interagency communications.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("There are two types of radios scanners: handheld and desktop. I strongly advise you to go with a handheld model. You’re going to want something portable should you need to evacuate. As you research different models, be aware that handheld units don’t usually come with an AC power cord. Fortunately, power adapters are readily available. Otherwise, you’ll be relying upon battery power, and a radio scanner can eat through quite a few batteries if you keep it powered up constantly.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("More and more government agencies, such as police and fire departments, are moving from analog, such as AM or FM signals, to digital systems for their interagency communications. This means you’ll need to invest in a digital radio scanner to hear what’s going on. Digital scanners are far more expensive than the analog ones, so be forewarned. However, even if all you can afford is an analog scanner, all is not lost. See, the hidden value of a radio scanner is that with a little bit of homework, you can listen in on far more than just emergency services.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("One of the most popular resources for radio communications data is "), _c('a', {
    attrs: {
      "href": "http://RadioReference.com",
      "target": "_blank"
    }
  }, [_vm._v("RadioReference.com")]), _vm._v(". There, you can find common to relatively obscure frequencies in use in your local area. For example, I checked for those in my home county and found not only fire, police, and rescue departments but frequencies used by my town’s Department of Public Works (DPW), the security staff at a local resort, and even a school bus company. Those could be useful because the DPW and bus drivers are on the roads every day and their radio conversations could clue me in on weather conditions and traffic. The resort security radio traffic? Well, you just never know where the zombie uprising might start. Private businesses are far less likely to be cautious about the information they discuss on the radio, too, so you might glean a bit of information that would otherwise be kept off the air.")])]), _vm._v(" "), _c('p', {
    staticClass: "subhe"
  }, [_c('b', [_vm._v("Programming a Radio Scanner")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Nowadays, many scanners can be programmed quite easily using readily available software. In the days before home computers became commonplace, frequencies had to be keyed into the unit by hand. While you could save them as channels and organize them into user-defined sections called banks, it was still rather tedious. That said, I recommend you make a list of all the frequencies you program into your scanner. Hand keying is still an option and may be necessary should the scanner somehow lose memory and you don’t have access to a computer for reprogramming.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Most radio scanners today allow you to save at least a few hundred channels or frequencies. Designate one or two banks for local frequencies. Bear in mind that some agencies will have multiple frequencies. For example, a police department might have one frequency for dispatch, another for car-to-car communication, and another for handheld scanners.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Use a resource like "), _c('a', {
    attrs: {
      "href": "http://RadioReference.com",
      "target": "_blank"
    }
  }, [_vm._v("RadioReference.com")]), _vm._v(" to find the frequencies listed for agencies in your local area. At a minimum, program the frequencies for local police, fire, and rescue departments. I suggest you also include the county sheriff’s department and any local hospital security departments. At the state level, include:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceaa"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Department of Transportation")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceaa"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Department of Natural Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceaa"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Department of Health")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceaa"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("State Police")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("There are also several federal-level agencies from which you might glean valuable information. These include:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceaa"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Federal Bureau of Investigation (FBI)")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceaa"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Drug Enforcement Agency (DEA)")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceaa"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Bureau of Alcohol, Tobacco, Firearms, and Explosives (ATF)")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceaa"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("National Park Service")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceaa"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("US Marshals")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceaa"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Department of Homeland Security (DHS)")])])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("•"), _c('span', {
    staticClass: "spaceaa"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Federal Emergency Management Agency (FEMA)")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Many law enforcement agencies utilize encryption or coding when discussing sensitive information via radio. In my area, what you’ll hear is an officer or dispatcher saying, “Go to coded.” The transmission that follows will then be static or garbled until they switch back. They do this most often when the information being transmitted involves a juvenile’s name or the complaint being addressed is of a rather sensitive nature. I point this out because if you didn’t know this ahead of time, you might fear your scanner is on the fritz when a transmission suddenly goes static.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_vm._v("Even after programming all of those frequencies, you’ll likely still have plenty of space available. Break out your bug out plan (you "), _c('i', [_vm._v("do")]), _vm._v(" have a bug out plan, right?). Use your maps to make a list of all of the towns, big and small, that you’ll travel near or through when bugging out. Seek out and program the applicable radio frequencies for the police and other emergency services for each of those towns. This way, should you end up having to bug out, you can stay abreast of developments during your travels, including valuable information concerning possible roadblocks or other obstacles.")]), _vm._v(" "), _c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "10",
      "src": "images/line.jpg",
      "width": "799"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subhe1"
  }, [_c('b', [_vm._v("10 CODES")])]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_vm._v("The 10 Codes were developed to create a shorthand method of communicating between officers and dispatchers. More and more law enforcement agencies are moving away from the 10 Codes and just using plain talk when communicating via radio. However, it is still a good idea to keep a chart of the codes handy as the move to plain talk certainly isn’t universal from coast to coast.")]), _vm._v(" "), _c('p', {
    staticClass: "normalsat"
  }, [_c('b', [_vm._v("10-0")]), _vm._v(" Caution")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-1")]), _vm._v(" Unable to copy transmission")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-2")]), _vm._v(" Signal good/strong")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-3")]), _vm._v(" Stop transmitting")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-4")]), _vm._v(" Acknowledgment (OK)")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-5")]), _vm._v(" Relay")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-6")]), _vm._v(" Busy")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-7")]), _vm._v(" Out of service")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-8")]), _vm._v(" In service")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-9")]), _vm._v(" Repeat")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-10")]), _vm._v(" Fight in progress")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-11")]), _vm._v(" Dog case")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-12")]), _vm._v(" Stand by (stop)")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-13")]), _vm._v(" Weather or traffic report")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-14")]), _vm._v(" Prowler report")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-15")]), _vm._v(" Civil disturbance")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-16")]), _vm._v(" Domestic disturbance")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-17")]), _vm._v(" Meet complainant")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-18")]), _vm._v(" Quickly")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-19")]), _vm._v(" Return to [location]")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-20")]), _vm._v(" Location")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_c('b', [_vm._v("10-21")]), _vm._v(" Call [person] by telephone")])]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-22")]), _vm._v(" Disregard")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-23")]), _vm._v(" Arrived at scene")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-24")]), _vm._v(" Assignment completed")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-25")]), _vm._v(" Meet with [person]")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-26")]), _vm._v(" Detaining subject")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-27")]), _vm._v(" Driver’s license information")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-28")]), _vm._v(" Vehicle registration information")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-29")]), _vm._v(" Check for warrants")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-30")]), _vm._v(" Unnecessary use of radio")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-31")]), _vm._v(" Crime in progress")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-32")]), _vm._v(" Man with gun")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-33")]), _vm._v(" Emergency")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-34")]), _vm._v(" Riot")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-35")]), _vm._v(" Major crime alert")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-36")]), _vm._v(" Correct time")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-37")]), _vm._v(" Suspicious vehicle")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-38")]), _vm._v(" Stopping suspicious vehicle")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-39")]), _vm._v(" Urgent: use light, siren")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-40")]), _vm._v(" Silent run: no light, siren")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-41")]), _vm._v(" Beginning tour of duty")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-42")]), _vm._v(" Ending tour of duty")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-43")]), _vm._v(" Information")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-44")]), _vm._v(" Permission to leave")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-45")]), _vm._v(" Animal carcass")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-46")]), _vm._v(" Assist motorist")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-47")]), _vm._v(" Emergency road repairs")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-48")]), _vm._v(" Traffic standard repair")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-49")]), _vm._v(" Traffic light out at …")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-50")]), _vm._v(" Traffic accident")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-51")]), _vm._v(" Wrecker needed")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-52")]), _vm._v(" Ambulance needed")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-53")]), _vm._v(" Road blocked")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-54")]), _vm._v(" Livestock on highway")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-55")]), _vm._v(" Suspected DUI")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-56")]), _vm._v(" Intoxicated pedestrian")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-57")]), _vm._v(" Hit and run")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-58")]), _vm._v(" Direct traffic")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-59")]), _vm._v(" Convoy or escort")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-60")]), _vm._v(" Squad in vicinity")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-61")]), _vm._v(" Personnel in vicinity")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-62")]), _vm._v(" Reply to message")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-63")]), _vm._v(" Prepare to make written copy")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-64")]), _vm._v(" Message for local delivery")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-65")]), _vm._v(" Net message assignment")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-66")]), _vm._v(" Message cancellation")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-67")]), _vm._v(" Clear for net message")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_c('b', [_vm._v("10-68")]), _vm._v(" Dispatch information")])]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-69")]), _vm._v(" Message received")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-70")]), _vm._v(" Fire")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-71")]), _vm._v(" Advise nature of fire")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-72")]), _vm._v(" Report progress on fire")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-73")]), _vm._v(" Smoke report")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-74")]), _vm._v(" Negative")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-75")]), _vm._v(" In contact with [person]")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-76")]), _vm._v(" En route to [location]")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-77")]), _vm._v(" Estimated time of arrival (ETA)")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-78")]), _vm._v(" Need assistance")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-79")]), _vm._v(" Notify coroner")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-80")]), _vm._v(" Chase in progress")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-81")]), _vm._v(" Breathalyzer")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-82")]), _vm._v(" Reserve lodging")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-83")]), _vm._v(" Work school crossing")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-84")]), _vm._v(" If meeting, advise ETA")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-85")]), _vm._v(" Delayed due to [reason]")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-86")]), _vm._v(" Officer/operator on duty")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-87")]), _vm._v(" Pick up/distribute checks")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-88")]), _vm._v(" Present telephone number")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-89")]), _vm._v(" Bomb threat")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-90")]), _vm._v(" Bank alarm")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-91")]), _vm._v(" Pick up prisoner/subject")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-92")]), _vm._v(" Improperly parked vehicle")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-93")]), _vm._v(" Blockade")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-94")]), _vm._v(" Drag racing")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-95")]), _vm._v(" Prisoner/subject in custody")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-96")]), _vm._v(" Mental subject")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-97")]), _vm._v(" Check (test) signal")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-98")]), _vm._v(" Prison/jail break")]), _vm._v(" "), _c('p', {
    staticClass: "normalsa"
  }, [_c('b', [_vm._v("10-99")]), _vm._v(" Wanted/stolen indicated")])]), _vm._v(" "), _c('p', {
    staticClass: "imageta"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "10",
      "src": "images/line.jpg",
      "width": "799"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00149478","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter1.vue
// module id = 75
// module chunks = 0